<template>
  <div
    v-if="currentUser"
    class="system-period-text"
    aria-live="polite"
    title="Tanggal transaksi berjalan & periode akuntansi"
  >
    <div class="period-date">{{ loading ? '…' : dateLabel }}</div>
    <div class="period-month">{{ loading ? '…' : periodLabel }}</div>
  </div>
</template>

<script>
import { contextDate, contextPeriod } from '@/models/accounting-current-context'

export default {
  name: 'AccountingSystemPeriod',
  computed: {
    currentUser() { return this.$store.state.auth?.user },
    state() { return this.$store.state.accountingContext || {} },
    loading() { return this.state.loading },
    dateLabel() { return contextDate(this.state.data?.transactionDate) },
    periodLabel() { return contextPeriod(this.state.data) },
  },
}
</script>

<style scoped>
.system-period-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  white-space: nowrap;
  text-transform: none !important;
  letter-spacing: 0 !important;
  user-select: none;
}

.period-date {
  font-size: 12px;
  font-weight: 700;
  color: #135b51;
  line-height: 1.2;
}

.period-month {
  font-size: 10.5px;
  font-weight: 500;
  color: #62786f;
  line-height: 1.15;
}

@media (max-width: 600px) {
  .period-date {
    font-size: 11px;
    line-height: 1.15;
  }
  .period-month {
    font-size: 9px;
    line-height: 1.1;
  }
}
</style>
